export const getCountLabel = (count: number | string | undefined, loading: boolean) => {
  return loading || !count ? '' : ` (${count})`;
};
